export default "__VITE_ASSET__DXbD4rhZ__"